<template>
  <a v-if="type === 'list'" href="javascript:void(0);" @click="showModal()">{{
    operationType ? "转单" : "派单"
  }}</a>

  <a-button v-else-if="type === 'detail'" type="primary" @click="showModal()">{{
    operationType ? "转单" : "派单"
  }}</a-button>
  <a-button v-else-if="type === 'form'" type="primary" @click="showModal()">保存并派单 </a-button>
  <a-modal :confirmLoading="loading" :centered="true" v-model:visible="visible" @ok="handleOk()">
    <template #title>
      <h4 class="flow-model-title">{{ operationType ? "转单" : "派单" }}</h4>
    </template>
    <a-form layout="vertical">
      <a-form-item label="接单人" :required="true">
        <!-- <user-select
          v-model:value="formRef.acceptUserId"
          @change="userChange"
          :max-count="1"
        ></user-select> -->
        <maintenance-team-select
          @change="userChange"
          v-model:value="formRef.acceptUserId"
          :max-count="1"
        ></maintenance-team-select>
      </a-form-item>

      <a-form-item label="备注">
        <a-textarea
          v-model:value="formRef.remark"
          show-count
          placeholder="请输入备注"
          :rows="4"
          :maxlength="200"
        >
        </a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { Modal, message } from "ant-design-vue";
import { PropType, computed, defineComponent, reactive, toRefs, createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { TicketAssignService, TicketAssignReq } from "./service";
import { useRouter } from "vue-router";
import { MaintenanceTeamSelect } from "@/components";
export default defineComponent({
  isGlobal: true,
  name: "TicketAssignBtn",
  props: {
    type: {
      type: String,
      default: "list",
    },
    record: {
      type: Object as PropType<any>,
    },
    operationType: {
      //对应id key值
      type: Number,
      default: 0, //操作类型：0-派单 1-转单
    },
    afterFn: {
      type: Function,
      default: () => {},
    },
    ticketType:{
      type: String,
      default: "bx",
    }
  },
  emits: ["refresh"],
  components: {
    MaintenanceTeamSelect,
  },
  setup(props, { emit }) {
    const state = reactive(<
      {
        loading: boolean;
        visible: boolean;
      }
    >{
      loading: false,
      visible: false,
    });
    const formRef = reactive(new TicketAssignReq());
    const router = useRouter();
    const { run: runTicketAssign, loading: submitLoading = false } =
      TicketAssignService.useTicketAssignApi();
    const showModal = async () => {
      // state.approvalContent = "";
      let x = await props.afterFn();
      if (!x && props.type == "form") {
        return;
      }
      state.visible = true;
    };
    const userChange = (e) => {
      // console.log("🚀 ~ file: index.vue:89 ~ userChange ~ e:", e);
      formRef.acceptUserName = e[0].name;
    };
    const handleOk = async () => {
      if (formRef.acceptUserId == "") {
        message.warn("接单人不可为空");
        return;
      }
      formRef.operationType = props.operationType;
      if (props.type != "form") {
        await runTicketAssign(props.record.id, formRef,props.ticketType);
        emit("refresh");
      } else {
        emit("refresh", formRef);
      }
      state.visible = false;
      formRef.acceptUserId = "";
      formRef.remark = "";
    };

    return {
      ...toRefs(state),
      showModal,
      handleOk,
      formRef,
      userChange,
    };
  },
});
</script>
<style scoped>
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;

  display: inline-block;
}
.flow-model__subtitle {
}
.mt14 {
  margin-top: -14px;
}
.flow-model-subtitle {
  font-size: 14px;
  padding-left: 10px;
}
</style>
